import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-project-development',
  standalone: true,
  imports: [],
  templateUrl: './project-development.component.html',
  styleUrls: ['./project-development.component.css'],
})
export class ProjectDevelopmentComponent implements OnInit {
  isHovering1 = false;
  isHovering2 = false;
  isHovering3 = false;
  isHovering4 = false;
  isHovering5 = false;
  isHovering6 = false;
  isHovering7 = false;
  isHovering8 = false;
  isHovering9 = false;
  isHovering10 = false;
  isHovering11 = false;
  isHovering12 = false;
  isHovering13 = false;
  isHovering14 = false;

  projectName: string;
  projectId: number;
  projectIdentifier: string;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['name'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('projectId')
        ? parseInt(params.get('projectId'))
        : null;
    });
  }

  navigateToProjectRevision() {
    this.router.navigate(['/project-revision']);
  }

  navigateToProjectDesign() {
    this.router.navigate(['/project-design', 'drawing']);
  }

  navigateToTendering() {
    this.router.navigate([this.projectId, 'tendering'], {
      queryParams: {
        name: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }

  handleClose() {
    this.router.navigate([`/projects`]);
  }
}
